import * as React from "react";
import Breadcrumb from "../components/breadcrumb";
import Layout from "../layout/layout";
export default class Contact extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let NavList = [
            { Text: 'Social Responsibility', Link: '' }
        ];
        return (React.createElement(Layout, null,
            React.createElement("div", { className: "social-responsibility" },
                React.createElement(Breadcrumb, { NavList: NavList }),
                React.createElement("h5", null, "OUR COMMITMENT"),
                React.createElement("h1", null, "SOCIAL RESPONSIBILITY"),
                React.createElement("div", { className: "social-content" },
                    React.createElement("p", null, "In Alberta, we all have a role to play in being socially responsible."),
                    React.createElement("p", null, "At Connect Logistics we support the responsible use of Alcohol in Alberta for anyone over the age of 18 yrs old."),
                    React.createElement("p", null, "For our Industry partners, being responsible means not only complying with legislation, but going the extra mile to ensure the highest standards of safety and service meets and exceeds the needs of the public."),
                    React.createElement("p", null, "We encourage you to check out the following websites"),
                    React.createElement("ul", null,
                        React.createElement("li", null,
                            React.createElement("a", { href: "http://www.drinksenseab.ca/" }, "DrinkSense")),
                        React.createElement("li", null,
                            React.createElement("a", { href: "https://aglc.ca/liquor/responsible-liquor-service" }, "AGLC")),
                        React.createElement("li", null,
                            React.createElement("a", { href: "https://bestbarnone.drinksenseab.ca/" }, "Best Bar None")),
                        React.createElement("li", null,
                            React.createElement("a", { href: "https://www.saddalberta.com/" }, "SADD Alberta")),
                        React.createElement("li", null,
                            React.createElement("a", { href: "https://madd.ca/" }, "MAAD")),
                        React.createElement("li", null,
                            React.createElement("a", { href: "https://al-anon.ab.ca/" }, "Al-Anon")),
                        React.createElement("li", null,
                            React.createElement("a", { href: "http://fasd.alberta.ca/" }, "FASD")))))));
    }
}
;
//# sourceMappingURL=social-responsibility.js.map